import { axiosV2 } from "config/@axios";

export const FETCH_ACTIVE_DEVICES = "activeDevices::activeDevices";
export const FETCH_ACTIVE_DEVICES_SUCCESS =
  "activeDevices::activeDevicesSuccess";
export const FETCH_ACTIVE_DEVICES_FAILED = "activeDevices::activeDevicesFailed";
export const FETCH_DELETE_ACTIVE_DEVICES = "activeDevices::activeDeviceDelete";
export const fetchActiveDevices = () => dispatch => {
  dispatch({
    type: FETCH_ACTIVE_DEVICES
  });

  return axiosV2
    .get(`tokens`)
    .then(response => {
      dispatch({
        type: FETCH_ACTIVE_DEVICES_SUCCESS,
        payload: {
          activeDevices: response.data
        }
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_ACTIVE_DEVICES_FAILED,
        payload: {
          errorText: err.errorMessage
        }
      });
    });
};

export const fetchDeleteActiveDevice = message => ({
  type: FETCH_DELETE_ACTIVE_DEVICES,
  payload: {
    message
  }
});
